<!-- 装箱操作日志 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入装箱记录关键词"
            ></Input>
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.account_name"
                placeholder="对应的操作员帐号"
            ></Input>
            <DatePicker
                class="w200 mr24 mb24"
                type="daterange"
                split-panels
                placement="bottom-start"
                placeholder=" 开始时�?�?截止时间 "
                separator=" �?"
                @on-change="changeDate"
            ></DatePicker>
            <Button
                class="header-btn theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <div>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="reasons">
                        <div>{{ row.reasons }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="user">
                        <div>{{ row.accounts ? row.accounts.user : "" }}</div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { packing_log_list } from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                start_date: "",
                end_date: "",
                keywords: "",
                account_name: "",
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "操作日志", slot: "reasons", align: "center" },
                { title: "操作账号", slot: "user", align: "center" },
                {
                    title: "操作时间",
                    key: "created_at",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            packing_log_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch(){
            this.storePrams.page = 1;
            this.getList();
        },
        changeDate(e) {
            if (e[0]) {
                this.storePrams.start_date = e[0];
                this.storePrams.end_date = e[1];
            } else {
                this.storePrams.start_date = "";
                this.storePrams.end_date = "";
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.page {
    margin-top: 24px;
    text-align: right;
}
.header-btn {
    background: var(--primary-color);
    margin: 0 24px 24px 12px;
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>